import React from 'react';
import {Field} from 'formik';
import _ from 'lodash';
import {ClickableFormOption, ClickableFormStructure, ClickableOptionWrapper} from '../../ClickableFormStructure';
let uid = _.uniqueId('input');

const Radio = ({children, label, fieldName}) => (
    <ClickableFormStructure label={label} name={fieldName}>
        {children}
    </ClickableFormStructure>
);

const FormRadioOption = ({children, index, option, fieldName, level}) => (
    <ClickableFormOption radio level={level} htmlFor={uid + index + fieldName} label={children}>
        <Field name={fieldName}>
            {({field}) => (
                <input
                    {...field}
                    type="radio"
                    name={field.name}
                    id={uid + index + fieldName}
                    checked={option.value === field.value || '' + option.value === '' + field.value}
                    onChange={() => field.onChange(field.name)(option.value)}
                />
            )}
        </Field>
    </ClickableFormOption>
);

Radio.Option = FormRadioOption;
Radio.OptionWrapper = ClickableOptionWrapper;
export {Radio, FormRadioOption, ClickableOptionWrapper};
